import { useQuery } from "@tanstack/react-query";
import { getEmailsSentForOrder } from "../ordersApi";

export const useEmailsSentForOrder = (orderId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["orders", orderId, "emails"],
    queryFn: ({ signal }) => getEmailsSentForOrder(orderId, signal),
  });
  return { emails: data, isLoading };
};
